import { render, staticRenderFns } from "./ComplementoCartaPorteIngresoPdf.vue?vue&type=template&id=1910c5dc&"
import script from "./ComplementoCartaPorteIngresoPdf.vue?vue&type=script&lang=js&"
export * from "./ComplementoCartaPorteIngresoPdf.vue?vue&type=script&lang=js&"
import style0 from "./ComplementoCartaPorteIngresoPdf.vue?vue&type=style&index=0&id=1910c5dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports